import { useQuery } from 'react-query'

import { useSettings } from '@/hooks/use-settings'
import testnetMarkets from '@/root/cypress/fixtures/orderbook-markets.json'
import { fetchOrderbookMarkets } from '@/utils/apis/orderbook'

const useFetchAllMarkets = (enabled?: boolean) => {
  const { data: settingsData } = useSettings()

  return useQuery({
    queryKey: ['orderbook-market'],
    queryFn: async () => {
      const markets = await fetchOrderbookMarkets()
      return markets
    },
    initialData: testnetMarkets.data,
    refetchOnWindowFocus: false,
    enabled: enabled ?? Boolean(settingsData?.orderbook_feature_enabled),
  })
}

export default useFetchAllMarkets
